<template>
	<section class="video-page page">

    <section class="clips-wrapper mauto text-center">
      <article class=""
               v-for="(item,index) in data"
               :key="index">
        <iframe width="420" height="315"
                :src="'http://www.youtube.com/embed/' + item.snippet.resourceId.videoId + '?version=3&enablejsapi=1'">
        </iframe>
      </article>
    </section>

  </section>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		name: 'video-page',
		data () {
			return {
			}
		},
    created () {
      this.$store.dispatch('get_utube_clips')
      this.$store.commit('SET_STATE_KEY', {name: 'data', val: []})
    },
		computed: {
			...mapState({
        data: 'data'
      })
		},
		methods: {
		}
	}
</script>

<style lang="less">
	.video-page {
    padding-top: 120px;
    .clips-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      & > article {
        margin-bottom: 40px;
        @media only screen and (min-width: 860px) {
          &:nth-child(odd) {
            margin-right: 20px;
          }
        }
      }
    }
	}
</style>